// Created by Trusted Friend Consulting
(function () {
  // === EDIT THESE VALUES ===
  const MAX = "1200px"; // Form max width on desktop (example: "1100px", "1200px", "1400px")
  const BUTTON_FONT_SIZE = "1.3rem"; // Submit button font size (example: "1.05rem", "1.1rem", "18px")
  // ========================

  function apply(embed) {
    if (!embed || !embed.shadowRoot) return;

    // Set CSS variable on the wrapper inside shadow root
    const wrapper = embed.shadowRoot.querySelector('[data-sizing="form-wrapper"]');
    if (wrapper) {
      wrapper.style.setProperty("--inline-container-max-width", MAX);
      wrapper.style.setProperty("--container-max-w", MAX); // belt-and-suspenders
    }

    // Also force the form container to 100% width
    const container = embed.shadowRoot.querySelector('[data-testid="form-container"]');
    if (container) {
      container.style.maxWidth = MAX;
      container.style.width = "100%";
    }

    // Increase the submit button font size (inside Shadow DOM)
    // NOTE: We inject a <style> tag into the shadow root because theme CSS cannot style shadow DOM contents.
    const sr = embed.shadowRoot;

    // Avoid injecting multiple times
    if (!sr.getElementById("tfc-shopify-forms-style")) {
      const style = document.createElement("style");
      style.id = "tfc-shopify-forms-style";
      style.textContent = `
        /* === EDIT THIS VALUE VIA BUTTON_FONT_SIZE ABOVE === */
        button[type="submit"] {
          font-size: ${BUTTON_FONT_SIZE} !important;
        }
      `;
      sr.appendChild(style);
    }
  }

  function init() {
    document.querySelectorAll("shopify-forms-embed").forEach(apply);

    const obs = new MutationObserver(() => {
      document.querySelectorAll("shopify-forms-embed").forEach(apply);
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
